import ContainersProvider from "./container_provider";

export default [...ContainersProvider];
